import { Button, Modal, Typography, Divider } from 'antd';
import * as React from 'react';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import { WarningOutlined } from "@ant-design/icons";
import LocalStorage from "../../services/LocalStorage";
import AntdCustomButton from '../buttons/AntdCustomButton';

interface FCProps {
  visible,
  setVisible
}

const ResetModal: React.FC<FCProps> = observer(({visible, setVisible}) => {
  const { t } = useTranslation();

  const { Text } = Typography;

  return (
    <div>
      <Modal
        title={<><WarningOutlined /> {t('Reset form')}</>}
        open={visible}
        onCancel={() => {
         setVisible(false);
        }}
        footer={[
      
          <AntdCustomButton appearance='default' key="cancel" onClick={() => {
            setVisible(false);
          }}>
            {t('Cancel')}
          </AntdCustomButton>,

          
          <AntdCustomButton appearance='important' key="add-page" onClick={
            () => {
              LocalStorage.clear();

              // reload the page
              window.location.reload();
            }
          }>
            {t('Reset form')}
          </AntdCustomButton>
        ]}>
        <Text>{t("Do you really want to reset the entire form? All progress will be lost.")}</Text>
        <Divider />
      </Modal>
    </div>
  );
});

export default ResetModal;
